export interface StatusOption {
  value: string;
  label: string;
  stage: string;
  hidden: boolean;
  disabledReason: string | null;
}

export const borrowerStatusOptions: StatusOption[] = [
  {
    value: 'noAttempt',
    label: 'No Attempt',
    stage: 'active',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'attempted',
    label: 'Attempted',
    stage: 'active',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'inContact',
    label: 'In Contact',
    stage: 'active',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'validating',
    label: 'Validating',
    stage: 'active',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'needsAttention',
    label: 'Needs Attention',
    stage: 'active',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'pendingPpp',
    label: 'Pending PPP',
    stage: 'active',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'readyToSubmit',
    label: 'Ready to Submit',
    stage: 'active',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'docPrep',
    label: 'Doc Prep',
    stage: 'active',
    hidden: true,
    disabledReason: null
  },
  {
    value: 'dealInProgress',
    label: 'Deal In Progress',
    stage: 'active',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'renewalsEligible',
    label: 'Renewals Eligible',
    stage: 'active',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'funded',
    label: 'Funded',
    stage: 'funded',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'notInterestedInRenewal',
    label: 'Not Interested In Renewal',
    stage: 'funded',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'onHold',
    label: 'On Hold',
    stage: 'inactive',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'doNotContact',
    label: 'Do Not Contact',
    stage: 'inactive',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'dead',
    label: 'Dead',
    stage: 'inactive',
    hidden: false,
    disabledReason: null,
  },
  {
    value: 'prospect',
    label: 'Prospect',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'referral',
    label: 'Referral',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'needsMoreTime',
    label: 'Needs More Time',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'noContactMade',
    label: 'No Contact Made',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'doesNotQualify',
    label: 'Does Not Qualify',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
  {
    value: 'lostContact',
    label: 'Lost Contact',
    stage: 'inactive',
    hidden: true,
    disabledReason: null,
  },
];
